import { TextProps } from '@abyss/web/ui/Text';
import React from 'react';

import { TruncatedTextStyled } from './TruncatedText.styled';

interface TruncatedTextProps {
  maxWidth?: string;
  showFullTextOnHover?: boolean;
  children?: string;
  // Abyss 2.0 requires this component should support asElement prop too
}

export const TruncatedText = ({
  maxWidth,
  showFullTextOnHover = true,
  children,
  ...props
}: TruncatedTextProps & TextProps) => {
  const hoverTitle = showFullTextOnHover ? children : undefined;

  const Wrapper = showFullTextOnHover ? 'span' : React.Fragment;

  return (
    <Wrapper title={hoverTitle}>
      <TruncatedTextStyled
        css={{
          '&.abyss-text-root': {
            maxWidth,
          },
        }}
        {...props}
      >
        {children}
      </TruncatedTextStyled>
    </Wrapper>
  );
};
